import Markdown from 'react-markdown';
import rehypeRaw from 'rehype-raw';
import remarkGfm from 'remark-gfm';

interface MarkdownViewerProps {
  markdown: string;
}

export const MarkdownViewer = ({ markdown }: MarkdownViewerProps) => {
  return (
    <div className="markdown-content">
      <Markdown rehypePlugins={[rehypeRaw]} remarkPlugins={[remarkGfm]}>
        {markdown}
      </Markdown>
    </div>
  );
};
